import { Box, makeStyles, Typography } from "@material-ui/core";
import React from "react";
import { useHistory } from "react-router";

import { CustomButton } from "@/components/Button";
import { layoutTokens, semanticColors as colors, textStyles } from "@/designTokens";
import theme from "@/theme";

import EmptyMessageImage from "@assets/image/ds_v2_message_empty.png";

const useStyles = makeStyles({
  root: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "calc(100vh - 166px)",
    [theme.breakpoints.up("md")]: { minHeight: 0 },
  },
  panel: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: layoutTokens.space[24],
    width: "100%",
    textAlign: "center",
    [theme.breakpoints.up("md")]: {
      maxWidth: 560,
      background: colors["surface/card"],
      borderRadius: layoutTokens.radius.lg,
      padding: "40px 48px",
    },
  },
  image: {
    width: 200,
    height: 118,
    overflow: "hidden",
    position: "relative",
    "& img": { position: "absolute", width: "100%", height: "168.55%", top: "-35.48%", left: 0 },
  },
  title: {
    ...textStyles["SP/Heading/H2"],
    marginBottom: layoutTokens.space[8],
    [theme.breakpoints.up("md")]: textStyles["PC/Heading/H4"],
  },
  description: {
    ...textStyles["SP/Body/Large"],
    color: colors["text/secondary"],
    [theme.breakpoints.up("md")]: { ...textStyles["PC/Body/Large"], textAlign: "left" },
  },
  button: { width: "100%", [theme.breakpoints.up("md")]: { maxWidth: 360 } },
});
export const MessageEmpty: React.FC = () => {
  const classes = useStyles();
  const history = useHistory();
  return (
    <Box className={classes.root}>
      <Box className={classes.panel}>
        <Box className={classes.image}>
          <img src={EmptyMessageImage} alt="" />
        </Box>
        <Box>
          <Typography component="h2" className={classes.title}>
            まだメッセージが届いていません
          </Typography>
          <Typography className={classes.description}>
            最適なメッセージをお送りするため、年収や勤続年数に変更がある場合は情報を更新してください。
          </Typography>
        </Box>
        <Box className={classes.button}>
          <CustomButton tone="primary" buttonSize="L" fullWidth onClick={() => history.push("/settings")}>
            アカウント情報を更新する
          </CustomButton>
        </Box>
      </Box>
    </Box>
  );
};
